import { collection, getDocs, QueryDocumentSnapshot, DocumentData } from "firebase/firestore";
import { getDb } from "@/services/firebase/config";
import type { TutorialType } from "@/types/tutorial/Tutorial";
import { TutorialCategory } from "@/types/tutorial/Category";

const COLLECTION_NAME = "tutoriais";

const VALID_CATEGORIES = new Set<string>(Object.values(TutorialCategory));

function mapDoc(doc: QueryDocumentSnapshot<DocumentData>): TutorialType {
  const data = doc.data();
  const raw = data.category;
  const category =
    typeof raw === "string" && VALID_CATEGORIES.has(raw)
      ? (raw as TutorialCategory)
      : TutorialCategory.CONSUMIDOR;
  return {
    id: doc.id,
    title: data.title ?? "",
    link: data.link ?? "",
    category,
  };
}

class GetTutorials {
  execute = async (): Promise<TutorialType[]> => {
    const db = getDb();
    const col = collection(db, COLLECTION_NAME);
    const snapshot = await getDocs(col);
    const list = snapshot.docs.map(mapDoc);
    list.sort((a, b) => a.title.localeCompare(b.title));
    return list;
  };
}

export { GetTutorials };
